// extracted by mini-css-extract-plugin
module.exports = {"root":"header-logo_root__J8hZK","selectedSubMenu":"header-logo_selectedSubMenu__ICbTh","searchPage":"header-logo_searchPage__Vhf5e"};